import { z } from 'zod';

export const agentConfigurationSearchSchema = z.object({
    automation_id: z.string().optional().catch(undefined),
    tab: z.enum(['automations', 'skills']).optional().catch(undefined),
});
